export class QueryParamsModel<T> {
    filter: any;
    sortOrder: string;
    sortField: (keyof T & string) | undefined;
    pageNumber: number;
    pageSize: number;

    constructor(filter: any,
                sortOrder = 'asc',
                sortField: (keyof T & string) | undefined = undefined,
                pageNumber = 0,
                pageSize = 30) {
        this.filter = filter;
        this.sortOrder = sortOrder;
        this.sortField = sortField;
        this.pageNumber = pageNumber;
        this.pageSize = pageSize;
    }
}
